import { createTheme } from "@mui/material/styles";
import { GlobalStyles } from "@mui/material";
import "@fontsource/kalnia/300.css";
import "@fontsource/kalnia/400.css";
import "@fontsource/kalnia/500.css";
import "@fontsource/kalnia/600.css";
import "@fontsource/kalnia/700.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import { esES } from "@mui/x-date-pickers";
import { esES as coreEsES } from "@mui/material/locale";
import { esES as dataGridEsES } from "@mui/x-data-grid";

export const globalStyles = (
  <GlobalStyles
    styles={{
      html: { minHeight: "100%", height: "100%" },
      body: { minHeight: "100%", height: "100%", margin: 0 },
      "#root": { minHeight: "100%", height: "100%" },
    }}
  />
);

export const theme = createTheme(
  {
    typography: {
      fontFamily: '"Montserrat", sans-serif',
      h1: {
        fontFamily: '"Kalnia", sans-serif !important',
        fontSize: "2.3rem",
        "@media (max-width: 600px)": {
          fontSize: "1.8rem",
        },
        fontWeight: 500,
      },
      h2: {
        fontFamily: '"Kalnia", sans-serif !important',
      },
      h3: {
        fontFamily: '"Kalnia", sans-serif !important',
      },
      h4: {
        fontFamily: '"Kalnia", sans-serif !important',
      },
      h5: {
        fontFamily: '"Kalnia", sans-serif !important',
      },
      h6: {
        fontFamily: '"Kalnia", sans-serif !important',
      },
    },
    components: {
      MuiCardContent: {
        styleOverrides: {
          root: {
            padding: "2rem",
            "@media (max-width: 600px)": {
              padding: "0.3rem", // Valor para dispositivos móviles
            },
          },
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            marginLeft: 0,
          }
        }
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: "16px",
            boxShadow: "unset",
            overflow: "visible",
          },
        },
      },
      MuiLink: {
        styleOverrides: {
          root: {
            textDecoration: "none",
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: "white",
            color: "black",
          },
        },
      },
      MuiTablePagination: {
        styleOverrides: {
          root: {
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
            {
              marginTop: 0,
              marginBottom: 0,
            },
          },
        },
      },

      MuiButton: {
        styleOverrides: {
          root: {
            transition: "all .3s",
            borderRadius: ".375rem",
            padding: "1rem",
            boxShadow: "none",
            textTransform: "none",
          },
        },
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            "&:before": {
              display: "none",
            },
          },
        },
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            padding: "0",
            color: "#8F95B2",
          },
        },
      },
      MuiInput: {
        styleOverrides: {
          root: {
            backgroundColor: "transparent !important",
            // height: "64px",
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            height: "64px",
            borderRadius: "5px",
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            fontWeight: 700,
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            borderBottom: "1px solid #EEEFF2",
            paddingLeft: "1.2rem",
            overflow: "visible",
          },
          scroller: {
            overflow: "visible !important",
          },
          indicator: {
            bottom: "-1px",
          },
        },
      },
    },
    palette: {
      primary: {
        main: "#018d36",
      },
      secondary: {
        main: "#000",
      },
    },
  },
  esES,
  coreEsES,
  dataGridEsES
);

export default theme;
